(() => {
  if (customElements.get('dag-bracket-selector')) return;
  customElements.define('dag-bracket-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('select');
      this.result = this.querySelector('[data-bracket-result]');
      this.status = this.querySelector('[data-bracket-status]');
      this.select?.addEventListener('change', () => this.load());
    }
    disconnectedCallback() { this.controller?.abort(); }
    async load() {
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      const option = this.select.selectedOptions[0];
      this.result.replaceChildren();
      this.status.textContent = '';
      this.result.removeAttribute('aria-busy');
      if (!option.value) return;
      this.status.textContent = this.dataset.loading;
      this.result.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(option.value, location.origin);
        url.searchParams.set('section_id', 'dag-bracket-details');
        url.searchParams.set('variant', option.dataset.variant);
        const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Bracket unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller.signal.aborted) return;
        const card = html.querySelector('[data-bracket-card]');
        if (!card || card.dataset.sku !== option.dataset.sku) throw new Error('Bracket mismatch');
        card.querySelector('[data-fitment-label]').textContent = option.dataset.fitment;
        const confirmation = card.querySelector('[name="properties[Vehicle confirmation]"]');
        confirmation.value = option.dataset.fitment;
        const board = card.querySelector('[name="properties[Board SKU]"]');
        board.value = this.dataset.boardSku;
        this.result.replaceChildren(document.importNode(card, true));
        this.status.textContent = '';
      } catch(error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = this.dataset.error;
        const link = document.createElement('a');
        link.href = option.value;
        link.textContent = this.dataset.view + ' #' + option.dataset.part;
        this.result.replaceChildren(link);
      } finally {
        if (this.controller === controller) this.result.removeAttribute('aria-busy');
      }
    }
  });
})();
